import moment from "moment"
import { DATE_TIME_FORMAT } from "./constants"

export const renderDateTime = (formattedDate, separator = '-', timePrefix = '', timePostfix = '') => {
  if(!formattedDate) return ""
  const dateMoment = moment(formattedDate, DATE_TIME_FORMAT)
  if (!dateMoment.isValid()) return ""
  return `${dateMoment.format('DD/MM/YYYY')} ${separator} ${timePrefix}${dateMoment.format('HH[h]mm')}${timePostfix}`
}

export const renderFullAddress = (address) => {
  let fullAddress = "";
  if (address.street) {
    fullAddress += address.street;
  }
  if (address.number) {
    fullAddress += (fullAddress ? ' ' : '') + address.number;
  }
  if (address.zip) {
    fullAddress += (fullAddress ? ', ' : '') + address.zip;
  }
  if (address.city) {
    fullAddress += (fullAddress ? ' ' : '') + address.city;
  }
  return fullAddress
}
